import { render, staticRenderFns } from "./DataConflictEntry.vue?vue&type=template&id=6eb99f1e&"
import script from "./DataConflictEntry.vue?vue&type=script&lang=js&"
export * from "./DataConflictEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports